module.exports = __webpack_public_path__ + "img/sense_online.baa733fa.png";